import React from 'react'
import styled from 'styled-components'

function WhatsappIcon() {
    return (
        <Container href="https://wa.me/96599505899">
            <h6>حجز المواعيد</h6>
            <img src = 'https://download.logo.wine/logo/WhatsApp/WhatsApp-Logo.wine.png' alt="واتساب المحامي محمد المظفر" />
            
        </Container>
    )
}

export default WhatsappIcon


const Container = styled.a`

position: fixed;
display: flex;
z-index: 1;
bottom: 0;
right: 0;
margin-right: 5px;
background: #040714;
margin: 10px;
margin-right: 20px;
border-radius: 10px;
opacity: 0.8;
align-items: center;
justify-content: center;
align-content: center;
text-align: center;
cursor: pointer;


h6 {
    
    text-align: center;
    margin-right: 15px;
}

img {

    width: 70px;
    height: 50px;
    position: -webkit-sticky; /* Safari */
    position: sticky;
    padding: 5px;
    
    
    


}

`